import {onMounted, onBeforeUnmount} from 'vue';
import {useMediaQuery} from '@malt/utils';

/**
 * Updates the sticky form position based on the guide hero element's position.
 * If the form is sticky in the header, calculate the top offset of the guide hero element and set the offset to the negative of the offset plus 180.
 */
export function useUpdateStickyFormOffset() {
    const {matchMedia} = useMediaQuery();

    function updateStickyFormOffset() {
        const aside = document.querySelector('.resource-page__aside') as HTMLElement;
        const asideSticky = document.querySelector('.resource-page__aside__sticky') as HTMLElement;
        const hero = document.querySelector('.resource-page__header') as HTMLElement;
        const heroTop = hero ? hero.getBoundingClientRect().top : 0;
        const asideTop = aside ? aside.getBoundingClientRect().top : 0;

        if (asideSticky && asideSticky.style) {
            const marginTop = matchMedia.value.max.Sm ? 0 : Math.round(heroTop - asideTop) + 100;
            asideSticky.style.marginTop = `${marginTop}px`;
        }
    }
    onMounted(() => {
        window.addEventListener('resize', updateStickyFormOffset);
        updateStickyFormOffset();
    });
    onBeforeUnmount(() => {
        window.removeEventListener('resize', updateStickyFormOffset);
    });
}
